import { useEffect, useState } from "react";
import intl from "components/i18n/ReactIntlWrapper";
import RequestStatusSelect from "./Request/RequestStatusSelect";
import RequestSelect from "./Request/RequestSelect";
import TimeOffSearchBar from "./TimeOffSearchBar";
import SearchIcon from "@mui/icons-material/Search";
import { PermissionsGate } from "../authorization/PermissionsGate";
import { SCOPES } from "common/permissions";
import { ENTITY_TYPE } from "common/constants";
import { useWorkflow } from "../Workflow/WorkflowContext";
import { Box, Button, Grid, Tooltip, FormControlLabel, Checkbox } from "@mui/material";

const TimeOffNavbar = ({ requestType, onSearch, HRView, setInput, input }) => {
  const [queryString, setQueryString] = useState<string>("");
  const [workflowLabelKeys, setWorkflowLabelKeys] = useState(null);
  const { workflow } = useWorkflow();

  useEffect(() => {
    setWorkflowLabelKeys(
      workflow?.states?.map((state) => ({
        label: state.labelKey,
        id: state.id,
      }))
    );
  }, [workflow]);

  const handleIncludeProcessedChange = (e) => {
    setInput({
      ...input,
      includeProcessed: e.target.checked,
    });
  };

  const handleSearchButton = () => {
    onSearch(queryString, input.idWorkflowState, input.IdEmployeeTimeOffType, input.includeProcessed);
  };

  const handleStatusChange = (e) => {
    if (e !== null) {
      setInput({
        ...input,
        idWorkflowState: e.id,
      });
    } else {
      setInput({
        ...input,
        idWorkflowState: null,
      });
    }
  };

  const handleRequestChange = (e) => {
    if (e !== null) {
      setInput({
        ...input,
        IdEmployeeTimeOffType: e.id,
      });
    } else {
      setInput({
        ...input,
        IdEmployeeTimeOffType: null,
      });
    }
  };

  return (
    <Box
      component="nav"
      className="container-fluid flex flex-wrap justify-between items-center my-4"
    >
      <Grid container spacing={2} alignItems="center">
          {HRView && (
            <PermissionsGate
              viewScopes={[SCOPES["timeoff.rrhh"]]}
              editScopes={[SCOPES["timeoff.rrhh"]]}
              entityType={ENTITY_TYPE.EMPLOYEE}
              viewRoles={[]}
              editRoles={[]}
            >
              <TimeOffSearchBar
                queryString={queryString}
                setQueryString={setQueryString}
              />
            </PermissionsGate>
          )}
          <RequestStatusSelect
            requestStatus={workflowLabelKeys}
            selectedStatus={input.idWorkflowState}
            handleStatusChange={handleStatusChange}
            isClearable={true}
          />
          <RequestSelect
            requestType={requestType}
            selectedRequest={input.IdEmployeeTimeOffType}
            handleRequestChange={handleRequestChange}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={input.includeProcessed}
                onChange={handleIncludeProcessedChange}
              />
            }
            label={intl.get("timeOff.includeProcessed")}
          />
          <Button
            variant="outlined"
            onClick={handleSearchButton}
            startIcon={<SearchIcon />}
            sx={{ height: 40 }}
          >
            {intl.get("jiraIssueSearch.search.button")}
          </Button>
        </Grid>
    </Box>
  );
};

export default TimeOffNavbar;
